import { render } from "./UserIndicator.vue?vue&type=template&id=32d1b538"
import script from "./UserIndicator.vue?vue&type=script&lang=js"
export * from "./UserIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__